var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"landing",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"col-10 mx-auto py-5 my-5"},[_c('h5',{staticClass:"section-title mb-5"},[_vm._v("Preguntas frecuentes")]),_c('section-privacy-politics',{attrs:{"content":_vm.SectionTerms}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }